import React, { useState, useEffect, useRef, useCallback, useLayoutEffect, useMemo } from 'react';
import { Box, Card, CircularProgress, Grid, Skeleton, Typography } from '@mui/material';
import { VariableSizeList } from 'react-window';
import { useNavigate } from 'react-router-dom';
import {
  useLazyGetAllNewsQuery,
  useDeleteNewsMutation,
  useGetNewsByIdQuery,
  useLazyGetNewsByIdQuery,
} from '../gnnApiSlice';
import { selectCurrentUser, selectNotificationNewsId, setGnnStatus, setNotificationNewsId } from '../../Auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import LikesModal from './LikesModal';
import PostNewsDialog from './PostNewsDialog';
import NewsRow from './NewsRow';
import useSocket from '../../../hooks/sockets/useSocket';
import { useTheme } from '@emotion/react';
import { useExpanded } from '../contexts/ExpandedContext';
import InfiniteLoader from 'react-window-infinite-loader';
import { empty } from '../../Gift/assets/index';
import { Newspaper } from '@mui/icons-material';
import { variants } from '../../../variants/variants';
import NewsComments from './NewsComments';
import CustomDialogBox from '../../../common/CustomDialogBox';
import NewsDetailsNavbar from './NewsDetailsNavbar';
import { resetPostNews } from '../gnnSlice';
import RowVirtualizerDynamic from './tanstack/RowVirtualizerDynamic';
import { useVirtualizer } from '@tanstack/react-virtual';
import PullToRefresh from 'react-simple-pull-to-refresh';
import AutoSizer from 'react-virtualized-auto-sizer';
import NewsHotizontalCard from './NewsHotizontalCard';

const NewsCardList = ({
  rows,
  handleCardClick,
  handleDeleteClick,
  handleEditClick,
  handleLikesClick,
  children,
  virtualizer,
  parentRef,
  showLoader,
  showDefault,
  showLoading,
  showEnd,
  handleMediaLoad,
  handleRefresh,
}) => {

const [story, ...items] = virtualizer.getVirtualItems();
    // console.log(story, items);
    return (
      <div style={{ height: '100%' }}>
        <AutoSizer disableWidth>
          {({ height }) => (
            <div
              ref={parentRef}
              className='List'
              style={{
                height: height,
                width: 400,
                overflowY: 'auto',
                contain: 'strict',
                border: '0px solid black',
                willChange: 'transform',
              }}
            >
              <div
                style={{
                  height: virtualizer.getTotalSize(),
                  width: '100%',
                  position: 'relative',
                }}
              >
                {children}
                <div
                  style={{
                    position: 'absolute',
                    top: -70,
                    left: 0,
                    width: '100%',
                    transform: `translateY(${items[0]?.start ?? 0}px)`,
                  }}
                >
                  <PullToRefresh
                    onRefresh={() =>
                      new Promise((resolve, reject) => {
                        setTimeout(() => {
                          handleRefresh();
                          resolve(true);
                        }, 500);
                      })
                    }
                  >
                    {items.map((virtualRow, ind) => (
                      <div key={virtualRow.key} data-index={virtualRow.index} ref={virtualizer.measureElement} >
                        {showLoader ? (
                            <>
                            {[1, 2, 3].map((item) => (
                              <Box key={item} sx={{ p: 2, borderBottom: '1px solid #f0f0f0' }}>
                                <Box sx={{ display: 'flex', gap: 2, mb: 1.5 }}>
                                  <Skeleton variant="rectangular" width={100} height={100} />
                                  <Box sx={{ flex: 1 }}>
                                    <Skeleton variant="text" width="80%" height={24} />
                                    <Skeleton variant="text" width="60%" />
                                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                                      <Skeleton variant="circular" width={24} height={24} />
                                      <Skeleton variant="circular" width={24} height={24} />
                                      <Skeleton variant="circular" width={24} height={24} />
                                    </Box>
                                  </Box>
                                </Box>
                                <Skeleton variant="text" width="100%" height={16} />
                                <Skeleton variant="text" width="100%" height={16} />
                                <Skeleton variant="text" width="60%" height={16} />
                              </Box>
                            ))}
                          </>
                        ) : showDefault ? (
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              width: '100%',
                              height: '30vh',
                              alignItems: 'center',
                            }}
                          >
                            <img style={{ width: '50%' }} src={empty} alt='pending' />
                            <Typography sx={{ fontSize: variants.TINY, p: 2, color: 'rgba(0,0,0,0.7)' }}>
                              No news found.
                            </Typography>
                          </Box>
                        ) : (
                          <div style={{ border: 'none' }}>
                            <NewsHotizontalCard
                              key={rows[virtualRow.index]?._id}
                              news={rows[virtualRow.index]}
                              handleCardClick={() => handleCardClick(rows[virtualRow.index]?._id)}
                              handleDeleteClick={(event) => handleDeleteClick(event, rows[virtualRow.index]?._id)}
                              handleLikesClick={(event) =>
                                handleLikesClick(event, rows[virtualRow.index]?.likes, rows[virtualRow.index]?._id)
                              }
                              handleEditClick={(event) => handleEditClick(event, rows[virtualRow.index])}
                              onMediaLoad={() => handleMediaLoad(virtualRow.index)}
                            />
                            {/* <NewsRow
                              key={rows[virtualRow.index]?._id}
                              news={rows[virtualRow.index]}
                              handleCardClick={() => handleCardClick(rows[virtualRow.index]?._id)}
                              handleDeleteClick={(event) => handleDeleteClick(event, rows[virtualRow.index]?._id)}
                              handleLikesClick={(event) =>
                                handleLikesClick(event, rows[virtualRow.index]?.likes, rows[virtualRow.index]?._id)
                              }
                              handleEditClick={(event) => handleEditClick(event, rows[virtualRow.index])}
                              onMediaLoad={() => handleMediaLoad(virtualRow.index)}
                            /> */}
                            {virtualRow.index === rows.length - 1 ? (
                              <>
                                {showLoading ? (
                                  <>
                                    {[1, 2, 3].map((item) => (
                                      <Box key={item} sx={{ p: 2, borderBottom: '1px solid #f0f0f0' }}>
                                        <Box sx={{ display: 'flex', gap: 2, mb: 1.5 }}>
                                          <Skeleton variant="rectangular" width={100} height={100} />
                                          <Box sx={{ flex: 1 }}>
                                            <Skeleton variant="text" width="80%" height={24} />
                                            <Skeleton variant="text" width="60%" />
                                            <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                                              <Skeleton variant="circular" width={24} height={24} />
                                              <Skeleton variant="circular" width={24} height={24} />
                                              <Skeleton variant="circular" width={24} height={24} />
                                            </Box>
                                          </Box>
                                        </Box>
                                        <Skeleton variant="text" width="100%" height={16} />
                                        <Skeleton variant="text" width="100%" height={16} />
                                        <Skeleton variant="text" width="60%" height={16} />
                                      </Box>
                                    ))}
                                  </>
                                ) : null}
                                {showEnd ? (
                                  <Box sx={{ textAlign: 'center', padding: '20px' }}>
                                    <Typography variant='body2'>You've reached the end</Typography>
                                  </Box>
                                ) : null}{' '}
                              </>
                            ) : null}
                          </div>
                        )}
                      </div>
                    ))}
                  </PullToRefresh>
                </div>
              </div>
            </div>
          )}
        </AutoSizer>
      </div>
    );
  };;

export default NewsCardList;
